import { render } from "./BlackListView.vue?vue&type=template&id=e8332888&scoped=true"
import script from "./BlackListView.vue?vue&type=script&lang=js"
export * from "./BlackListView.vue?vue&type=script&lang=js"

import "./BlackListView.vue?vue&type=style&index=0&id=e8332888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8332888"]])

export default __exports__